import React, { FC, useState } from 'react'

import { Txt, DecorationTitle, Card, LoadingIcon, Tag, Icon, Tooltip } from 'src/components/atoms'
import { SamlAuthToggle, LinkTxt } from 'src/components/molecules'
import {
  IdentityProviderSetting,
  SamlResetModal,
  ServiceProviderSetting,
} from 'src/components/organisms'

import { useGetCompany, useGetSamlIdp } from 'src/hooks'

type Props = {
  className?: string
}

export const SamlAuthSetting: FC<Props> = ({ className }) => {
  const { loading: loadingCompany, company, refetch: refetchCompany } = useGetCompany()
  const { loading: loadingSamlIdp, samlIdp } = useGetSamlIdp()

  const [isShowResetModal, setIsShowResetModal] = useState(false)

  const hasAllRequiredInput = samlIdp
    ? ((!!samlIdp.samlIdp.metadataFile && !!samlIdp.samlIdp.metadataFileName) ||
        !!samlIdp.samlIdp.metadataURL) &&
      !!samlIdp.samlIdp.attributeMapping.email
    : false

  return (
    <div className={className}>
      <Card padding="--s1">
        <div className="tw-full-justify">
          <div className="tw-flex tw-items-center">
            <DecorationTitle sizeType="l">SAML認証</DecorationTitle>
            {!loadingSamlIdp && samlIdp && (
              <div className="tw-ml-s1">
                {samlIdp.samlIdp.id ? (
                  <div className="tw-flex tw-items-center">
                    <Tag type="correct">
                      <div className="tw-flex tw-gap-s-4 tw-items-center">
                        <Icon path="check/soft/line" className="tw-w-s0" />
                        <Txt sizeType="s" className="tw-font-bold">
                          IdPメタデータ設定済み
                        </Txt>
                      </div>
                    </Tag>
                    <Tooltip
                      showIcon={false}
                      text="SAML認証がOFFの場合リセットを実行出来ます"
                      disabled={!company?.isSAMLEnabled}
                    >
                      <LinkTxt
                        sizeType="s"
                        className="tw-text-center tw-ml-s1 tw-font-bold tw-text-standardText-primary"
                        underlineType="onlyDefault"
                        onClick={() => !company?.isSAMLEnabled && setIsShowResetModal(true)}
                        disabled={company?.isSAMLEnabled}
                      >
                        リセット
                      </LinkTxt>
                    </Tooltip>
                  </div>
                ) : (
                  <Tag size="s" type="warning">
                    IdPメタデータ未設定
                  </Tag>
                )}
              </div>
            )}
          </div>
          {!loadingCompany && company && samlIdp && (
            <SamlAuthToggle
              company={company}
              afterUpdate={refetchCompany}
              hasAllRequiredInput={hasAllRequiredInput}
            />
          )}
        </div>

        <Txt className="tw-text-standardText-secondary tw-mt-s2">
          指定されたIdPとWORKSを接続して、より簡単かつ安全にログインできるようになります。自社のシステム担当者にお問い合わせのうえ、設定ください。
        </Txt>

        <div className="tw-mt-s4">
          {!loadingSamlIdp && !loadingCompany && company && samlIdp ? (
            <>
              <IdentityProviderSetting company={company} samlIdp={samlIdp} />
              <div className="tw-border-b tw-mt-s2 tw-border-border-primary tw-border-dotted" />
              <ServiceProviderSetting samlIdp={samlIdp} className="tw-mt-s2" />
            </>
          ) : (
            <div className="tw-centering">
              <LoadingIcon className="tw-text-2xl tw-mt-s2" />
            </div>
          )}
        </div>
      </Card>

      <SamlResetModal isOpen={isShowResetModal} onClose={() => setIsShowResetModal(false)} />
    </div>
  )
}
